'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SEARCH_RESULTS_PATH = '/jobs';
var ROOT_PATH = '/';

var FILTERS_HIGH_SALARY = exports.FILTERS_HIGH_SALARY = 'filtershighsalary';
var BROWSE_HIGH_SALARY = exports.BROWSE_HIGH_SALARY = 'browsehighsalary';
var MORE_OPTIONS = exports.MORE_OPTIONS = 'more options';
var LAST_SEARCH = exports.LAST_SEARCH = 'last';
var QUICK_SEARCH_CLASSIFICATION = exports.QUICK_SEARCH_CLASSIFICATION = 'browse';
var QUICK_SEARCH_CITY = exports.QUICK_SEARCH_CITY = 'browse';
var QUICK_SEARCH_GRADUATE = exports.QUICK_SEARCH_GRADUATE = 'graduate';
var JOB_CLASSIFICATION = exports.JOB_CLASSIFICATION = 'filters-job-classification';
var JOB_SUBCLASSIFICATION = exports.JOB_SUBCLASSIFICATION = 'filters-job-subclassification';
var JOB_LOCATION = exports.JOB_LOCATION = 'filters-job-location';
var JOB_AREA = exports.JOB_AREA = 'filters-job-area';
var JOB_SUBURB = exports.JOB_SUBURB = 'filters-job-suburb';
var SAVED_SEARCH = exports.SAVED_SEARCH = 'saved search';
var QUICK = exports.QUICK = 'quick';
var FILTERS = exports.FILTERS = 'filters';
var DID_YOU_MEAN = exports.DID_YOU_MEAN = 'did you mean';
var JOBMAIL = exports.JOBMAIL = 'jobmail';

var contains = function contains(searchvalue, target) {
  return searchvalue && searchvalue.indexOf(target) >= 0;
};

var startsWith = function startsWith(searchvalue, target) {
  return searchvalue && searchvalue.indexOf(target) === 0;
};

exports.default = function (query, prevLocation, searchTypeOverride) {
  var highpay = query.highpay;
  var searchtype = query.searchtype;
  var tracking = query.tracking;


  var value = void 0;

  if (searchTypeOverride) {
    value = searchTypeOverride;
  } else if (highpay) {
    value = startsWith(prevLocation, SEARCH_RESULTS_PATH) ? FILTERS_HIGH_SALARY : BROWSE_HIGH_SALARY;
  } else if (prevLocation === ROOT_PATH) {
    value = QUICK;
  } else if (startsWith(prevLocation, SEARCH_RESULTS_PATH)) {
    value = FILTERS;
  } else if (searchtype) {
    value = searchtype;
  } else if (contains(tracking, 'JobMail')) {
    value = JOBMAIL;
  } else {
    value = null;
  }

  return value;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-analytics/build/utils/evaluateSearchType.js
 ** module id = 410
 ** module chunks = 0
 **/